module.exports = __webpack_public_path__ + "static/media/psvita.5fddbda5.svg";